import { IncidentsGridNirvanaDataProvider } from '../dataProvider/IncidentsGridNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_QUARANTINE } from '../../../webcomponents.constants';

export class IncidentsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IncidentsGridNirvanaDataProvider);
  }
}
